/**
 * Global feature rollout flags the API puts on the logged-in user
 * (`user.features`, camel-cased by the API envelope, OPE-112). Permissions say what a staff member may do;
 * these say whether a feature is switched on at all. Company-specific
 * decisions are never made here: the API makes them per request and the
 * screens react to its 403 feature_disabled responses.
 */
export function hasFeature(user, name) {
    return !!(user && user.features && user.features[name]);
}

/** A 403 from the discount API because the feature is off for this company. */
export function isFeatureDisabled(error) {
    return !!error && error.status === 403 && error.feature !== undefined;
}



// WEBPACK FOOTER //
// ./app/utils/featureFlags.js